import { styled } from 'styled-components'
import { Button, DialogContent } from '@mui/material'

export const AddDriverButton = styled(Button)`
  border-radius: 8px !important;
`
export const DialogContentArea = styled(DialogContent)`
  padding: 20px !important;
  border-radius: 10px !important;
`
